export * from './wc-promotion-prize-modal';